<!-- Start Footer -->
<footer class="relative bg-gradient-to-b bg-earth-try">
  <!--<footer class="relative bg-earth-dark">-->
  <div class="container">
      <div class="grid grid-cols-1">
          <div class="relative py-12">
              <!-- Subscribe -->
              <div class="relative w-full">
                  <div class="grid md:grid-cols-12 grid-cols-1 gap-[30px]">
                      <div class="md:col-span-3">
                          <a href="#" class="flex justify-center md:justify-start focus:outline-none">
                              <img src="assets/images/logo_long_cut.png" class="" alt="">
                          </a>
                      </div><!--end col-->

                      <div class="md:col-span-9">
                          <ul class="list-disc footer-list ltr:md:text-right rtl:md:text-left text-center">
                              <li class="inline-block"><a routerLink="/visie" class="text-black/70 hover:text-earth-xdark duration-500 ease-in-out font-medium ltr:mr-4 rtl:ml-4"> Visie </a></li>
                              <li class="inline-block mt-[10px] md:mt-0"><a routerLink="/vacatures" class="text-black/70 hover:text-earth-xdark duration-500 ease-in-out font-medium ltr:mr-4 rtl:ml-4"> Vacatures </a></li>
                              <li class="inline-block mt-[10px] md:mt-0"><a routerLink="/contact" class="text-black/70 hover:text-earth-xdark duration-500 ease-in-out font-medium"> Contacteer ons </a></li>
                          </ul><!--end icon-->
                      </div><!--end col-->
                  </div><!--end grid-->
              </div>
              <!-- Subscribe -->
          </div>
      </div>
  </div><!--end container-->

  <div class="py-[30px] px-0 border-t border-earth-xdark">
      <div class="container text-center">
          <div class="grid md:grid-cols-2 items-center gap-6">
              <div class="ltr:md:text-left rtl:md:text-right text-center">
                  <p class="mb-0 text-black/70 font-medium">© {{ year }} <a href='#'>MUDICO</a>.</p>
              </div>

              <ul class="list-none ltr:md:text-right rtl:md:text-left text-center">
                  <li class="inline"><a href="https://www.facebook.com/mudico1" target="_blank" class="btn btn-icon text-lg border-none hover:text-earth-xdark text-black/70"><i class="uil uil-facebook-f align-middle" title="facebook"></i></a></li>
                  <li class="inline"><a href="https://www.instagram.com/groepspraktijk_mudico/" target="_blank" class="btn btn-icon text-lg border-none hover:text-earth-xdark text-black/70 ml-2"><i class="uil uil-instagram align-middle" title="instagram"></i></a></li>
                  <li class="inline"><a routerLink="/contact" class="btn btn-icon text-lg border-none hover:text-earth-xdark text-black/70 ml-2"><i class="uil uil-envelope align-middle" title="email"></i></a></li>
              </ul><!--end icon-->
          </div><!--end grid-->
      </div><!--end container-->
  </div>
</footer><!--end footer-->
<!-- End Footer -->
